<template>
  <div class="example">
    <div class="time">更新时间：{{mytime}}</div>
    <div class="title">成交金额</div>
    <div class="screen">
      <div v-if="info.rank">我的成绩</div>
      <div v-if="info.rank">第{{info.rank}}名</div>
      <div v-if="info.rank">{{info.user_data}}</div>
    </div>
    <div class="table_title flex_b">
      <div class="flex">
        <div>排名</div>
        <div>姓名</div>
      </div>
      <div>成交金额（元）</div>
    </div>

    <!-- 列表 -->
    <div class="list_box">
      <div class="van_list" :class="{'van_list_height' : isIphoneX}" @scroll="scrollEvent">
        <div v-for="(item,index) in leaderboard" :key="index" class="flex_a">
          <div class="keys">
            <img :src="imgPath + rankingImage[index]" v-if="index < 3" alt />
            <div v-else>{{index + 1}}</div>
          </div>
          <div class="example_name">{{item.nick_name}}</div>
          <div class="example_data">{{item.num}}</div>
        </div>
        <div class="loading">{{ isData ? '暂无更多数据' : '加载中~~'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rankingImage: ['example_one.png', 'example_two.png', 'example_three.png'],
      leaderboard: [],
      page: 1,
      rankId: '',
      isData: false,
      info: {},
      mytime: '',
    }
  },
  created() {
    var myDate = new Date()
    this.mytime = myDate.toLocaleString()
    this.rankId = this.$route.query.id
  },
  mounted() {
    this.getLeaderboard()
    this.getMemberRank()
  },
  methods: {
    scrollEvent(e) {
      if (
        e.srcElement.scrollTop + e.srcElement.clientHeight ==
        e.srcElement.scrollHeight
      ) {
        this.page++
        this.getLeaderboard()
        console.log('嘿嘿我在底部触发了')
      }
    },
    // 活动中的排行榜列表
    async getLeaderboard() {
      if (this.isData) return
      let res = await this.http('Rank.leaderboard', {
        page: this.page,
        limit: 20,
        type: 'price',
        rank_id: this.rankId,
      })
      this.leaderboard = Object.freeze(res.content.list)
      this.isData = res.content.count == this.leaderboard.length
      console.log(res)
    },
    getMemberRank() {
      this.http('Rank.getMemberRank', { rank_id: this.rankId }).then((e) => {
        e.content.user_rank_list.map((item) => {
          if (item.type == 'price') {
            this.info = item
          }
          console.log(item)
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.flex_b {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex_a {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}
.example {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: #ffe8dc
    url('https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/yj_img/exampleBg.png')
    no-repeat;
  background-size: 100% auto;
  .time {
    display: inline-block;
    padding: 7px 38px 6px 17px;
    border-radius: 25px;
    border: 1px solid #ffffff;
    color: #fff;
    font-size: 22px;
    margin-top: 130px;
    margin-left: 58px;
    line-height: 30px;
  }
  .title {
    color: #fff;
    font-size: 26px;
    font-weight: 400;
    line-height: 40px;
    text-align: center;
    margin-top: 60px;
  }

  .screen {
    color: #fff;
    font-weight: 400;
    font-size: 26px;
    display: flex;
    justify-content: space-between;
    width: 620px;
    margin: 64px auto 0;
    > div {
      min-width: 10%;
    }
  }

  //标题
  .table_title {
    margin: 80px 75px 0 62px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #bcbcbc;
    line-height: 37px;
    > div > div:first-child {
      margin-right: 95px;
    }
  }

  .list_box {
    background: #fff;
    margin: 0 32px;
    border-radius: 20px;
    font-size: 32px;
    padding-top: 40px;
    .van_list {
      height: 600px;
      overflow-y: scroll;
      > div + div {
        margin-top: 40px;
      }
      .keys {
        width: 64px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .example_name {
        width: 384px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .example_data {
        color: rgba(255, 78, 0, 1);
      }
    }
    .van_list_height {
      height: 1000px;
    }
    // 加载中
    .loading {
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>